import React, { useMemo, useEffect, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import { useNavigate } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Button } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  DeleteBathroomType,
  FetchBathroomTypes,
  UpdateBathroomType,
} from "../../apis/BathroomType";
import { AxiosError } from "axios";

const BathroomType = () => {
  const [BathroomTypes, setBathroomTypes] = useState([]);
  const [updateData, setUpdateData] = useState({
    bathroomTypeId: "",
    itemName: "",
    isChecked: true,
  });
  const [deleteData, setDeleteData] = useState({
    bathroomTypeId: "",
  });
  const [modal_standard, setModal_standard] = useState(false);
  const [modal_static, setModal_static] = useState(false);

  const tog_standard = () => setModal_standard((prev) => !prev);
  const tog_static = () => setModal_static((prev) => !prev);
  const navigate = useNavigate();

  const fetchBathroomTypes = async () => {
    const response = await FetchBathroomTypes(); // Assuming FetchHouseTypes is the correct function from your API
    setBathroomTypes(response.bathroomTypes);
  };
  useEffect(() => {
    fetchBathroomTypes();
  }, []);

  const handleUpdate = async () => {
    try {
      const { bathroomTypeId, itemName, isChecked } = updateData;

      console.log("itemName", itemName);
      const updatedBathroomType = await UpdateBathroomType(
        bathroomTypeId,
        itemName,
        isChecked ? "enabled" : "disabled",
      );

      if (updatedBathroomType) {
        toast.success("Bathroom Type Updated Successfully");
        setModal_standard(false);
        fetchBathroomTypes();
        navigate("/bathroom-type");
      } else {
        toast.error("Bathroom Type Update Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  const handleDelete = async () => {
    try {
      const { bathroomTypeId } = deleteData;

      const response = await DeleteBathroomType(bathroomTypeId);

      if (response) {
        toast.success("Bathroom Type Deleted Successfully");
        setModal_static(false);
        fetchBathroomTypes();
        navigate("/bathroom-type");
      } else {
        toast.error("Bathroom Type Deletion Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "English Item Name",
        accessor: "itemName.en",
      },
      {
        Header: "Arabic Item Name",
        accessor: "itemName.ar",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (value === "enabled" ? "Active" : "Inactive"),
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ value }) => new Date(value).toLocaleDateString(),
      },

      {
        Header: "Action",
        accessor: "actions",
        Cell: ({ row }) => (
          <div>
            <Button
              color="primary"
              className="btn-icon"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="mdi mdi-pencil"></i>
            </Button>
            <Button
              color="danger"
              className="btn-icon"
              onClick={() => handleDeleteClick(row.original)}
            >
              <i className="mdi mdi-delete"></i>
            </Button>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const handleEditClick = (bathroomType) => {
    setUpdateData({
      bathroomTypeId: bathroomType._id,
      itemName: bathroomType.itemName,
      isChecked: bathroomType.status === "enabled",
    });
    tog_standard(); // Open the modal
  };

  const handleDeleteClick = (bathroomType) => {
    setDeleteData({
      bathroomTypeId: bathroomType._id,
    });
    tog_static(); // Open the modal
  };
  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "Bathroom Type", link: "#" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0" fluid>
        <Breadcrumbs title="DATA TABLES" breadcrumbItems={breadcrumbItems} />
        <div className="p-6 flex flex-col gap-6 ">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              color="success"
              className="waves-effect waves-light me-1"
              onClick={() => navigate("/bathroom-type/add")}
            >
              Add Bathroom type
            </Button>
          </div>
          <TableContainer
            columns={columns || []}
            data={BathroomTypes || []}
            isPagination={false}
            // isGlobalFilter={false}
            iscustomPageSize={false}
            isBordered={false}
            customPageSize={10}
          />
        </div>

        {/* START: Modal EDIT  */}
        <Modal isOpen={modal_standard} toggle={tog_standard}>
          <ModalHeader toggle={() => setModal_standard(false)}>
            Modal Heading
          </ModalHeader>
          <ModalBody>
            <AvForm onValidSubmit={handleUpdate}>
              <div className="mb-3">
                <AvField
                  name="itemNameEn"
                  label="Bathroom Type Name In English"
                  placeholder="Type Something In English"
                  type="text"
                  errorMessage="Enter Name In English"
                  value={updateData.itemName.en}
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      itemName: {
                        en: e.target.value,
                        ar: updateData.itemName.ar,
                      },
                    })
                  }
                />
              </div>
              <div className="mb-3">
                <AvField
                  name="itemNameAr"
                  label="Bathroom Type Name In Arabic"
                  placeholder="Type Something In Arabic"
                  type="text"
                  errorMessage="Enter Name In Arabic"
                  value={updateData.itemName.ar}
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      itemName: {
                        en: updateData.itemName.en,
                        ar: e.target.value,
                      },
                    })
                  }
                />
              </div>
              <h4 className="card-title">Status</h4>
              <div className="form-check form-switch mb-3" dir="ltr">
                <Input
                  type="checkbox"
                  className="form-check-input"
                  checked={updateData.isChecked}
                  onChange={() =>
                    setUpdateData({
                      ...updateData,
                      isChecked: !updateData.isChecked,
                    })
                  }
                  id="customSwitch1"
                  defaultChecked
                />

                <Label className="form-check-label" htmlFor="customSwitch1">
                  {updateData.isChecked ? "Active" : "Inactive"}
                </Label>
              </div>
            </AvForm>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={tog_standard}
              color="light"
              className="waves-effect"
            >
              Close
            </Button>
            <Button
              type="button"
              onClick={handleUpdate}
              color="primary"
              className="waves-effect waves-light"
            >
              Save Changes
            </Button>
          </ModalFooter>
        </Modal>
        {/* END: Modal EDIT  */}

        {/* START: Modal DELETE */}

        <Modal isOpen={modal_static} toggle={tog_static} backdrop="static">
          <ModalHeader toggle={() => setModal_static(false)}>
            Static Backdrop
          </ModalHeader>
          <ModalBody>
            <p>Are you sure you want to delete this Bathroom type?</p>
            <ModalFooter>
              <Button type="button" color="light" onClick={tog_static}>
                Close
              </Button>
              <Button type="button" color="primary" onClick={handleDelete}>
                Save
              </Button>
            </ModalFooter>
          </ModalBody>
        </Modal>
        {/* END: Modal DELETE */}
      </Container>
      </div>
    </React.Fragment>
  );
};

export default BathroomType;
